import { Box, Button, styled, TextField } from "@mui/material"
import { colors } from "../../theme/colors"

export const Container = styled(Box)(
  ({
    marginBottom,
    marginTop,
  }: {
    marginBottom?: number
    marginTop?: number
  }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 18,
    marginTop,
    marginBottom,
    position: "relative",
  }),
)

export const CurrencySign = styled(Box)(() => ({
  height: 55,
  top: 42,
  right: 0,
  display: "flex",
  alignItems: "center",
  flex: 1,
  marginRight: 18,
}))

export const TextFieldStyled = styled(TextField)(() => ({
  "& input": {
    paddingRight: 32,
  },
}))

export const CurrencySignSpace = styled(Box)(() => ({
  width: "fit-content",
  color: "transparent",
  fontSize: 16,
  letterSpacing: 0,
  padding: "14px 8px 14px 18px",
  "& p": {
    letterSpacing: 0,
  },
}))

export const CurrencySignContainer = styled(Box)(() => ({
  position: "absolute",
  height: 55,
  top: 42,
  right: 0,
  display: "flex",
  alignItems: "center",
  width: `100%`,
  zIndex: 0,
  pointerEvents: "none",
}))

export const LimitsButton = styled(Button)(() => ({
  fontWeight: 400,
  height: "auto",
  margin: 0,
  padding: 0,
}))

export const CurrencyBoxStyle = {
  display: "flex",
  justifyContent: "center",
  height: "52px",
  width: "60px",
  borderRadius: "50%",
  alignItems: "center",
  backgroundColor: `${colors.lightGrey}`,
}

export const TextFieldWithCurrencyBox = { display: "flex", gap: "8px" }
